/**
 * @type {import('vuex').GetterTree<ROICalculatorState, ROICalculatorState>}
 */
export const getters = {
  currentStep: (state) => state.currentStep,

  steps: (state) => state.steps,

  stepsSet: (state) => state.stepsSet,

  hasPreviousStep: (state) =>
    state.steps.findIndex((s) => s === state.currentStep) > 0,
  hasNextStep: (state) =>
    state.steps.findIndex((s) => s === state.currentStep) <
    state.steps.length - 1,

  calculation: (state) => state.calculation,
};

/**
 * @typedef {import('./state').ROICalculatorState} ROICalculatorState
 */
